// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksBoardsList from './data'

export default function TasksBoardsListFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksBoardsList">
      <TasksBoardsList {...props}>
        {children}
      </TasksBoardsList>
    </Flow>
  )
}
